import { combineReducers } from "@reduxjs/toolkit";
import AuthSlice from "./AuthSlice";
import CollectionSlice from "./CollectionSlice";
const Slices = combineReducers({
  Auth: AuthSlice.reducer,
  Collection: CollectionSlice.reducer,
});
export default Slices;
